export function getFocusableElements(el) {
  return Array.from(
    el.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, ' +
        '[tabindex]:not([tabindex="-1"]), [contenteditable]'
    )
  ).filter((el) => el.offsetParent !== null)
}

function setSiblingsAriaHidden(targetEl, hide) {
  const siblings = Array.from(document.body.children).filter(
    (child) => child !== targetEl && !child.contains(targetEl)
  )
  siblings.forEach((sib) => {
    if (hide) {
      sib.setAttribute('aria-hidden', 'true')
    } else {
      sib.removeAttribute('aria-hidden')
    }
  })
}

export default {
  inserted(el) {
    el.setAttribute('role', 'dialog')
    el.setAttribute('aria-modal', 'true')

    setSiblingsAriaHidden(el, true)

    const focusableEls = getFocusableElements(el)
    if (focusableEls.length > 0) {
      focusableEls[0].focus({ preventScroll: true })
    }
    el.__focusTrapHandler__ = function (e) {
      if (e.key !== 'Tab') return

      const focusableEls = getFocusableElements(el)
      if (focusableEls.length === 0) return

      const firstEl = focusableEls[0]
      const lastEl = focusableEls[focusableEls.length - 1]

      const currentIndex = focusableEls.indexOf(document.activeElement)

      if (e.shiftKey) {
        // SHIFT + TAB
        if (document.activeElement === firstEl || currentIndex === -1) {
          e.preventDefault()
          lastEl.focus()
        }
      } else {
        // TAB
        if (document.activeElement === lastEl || currentIndex === -1) {
          e.preventDefault()
          firstEl.focus()
        }
      }
    }

    document.addEventListener('keydown', el.__focusTrapHandler__)
  },

  unbind(el) {
    document.removeEventListener('keydown', el.__focusTrapHandler__)
    delete el.__focusTrapHandler__
    setSiblingsAriaHidden(el, false)
  }
}


